import router from "@/router";

export default function setPageQueryParams(params) {
  let filters = {
    'builders[]': params.builder,
    'epochs[]': params.epoch,
    'regions[]': params.region,
    'streets[]': params.street,
    'types[]': params.type,
    'focus[]': params.focus
  }

  if (params.q) {
    Object.assign(filters, { q: params.q })
  }

  Object.keys(filters)
    .forEach((filter) => {
      if (filters[filter]?.[0] === undefined) {
        delete filters[filter]
      } else if (typeof filters[filter] === 'object' && Array.isArray(filters[filter])) {
        filters[filter] = filters[filter].map((id) => Number(id))
      }
    })

  if (Object.values(filters).length === 0) {
    let url = window.location.origin + window.location.pathname
    window.history.pushState({ path: url }, '', url)
  } else {
    router.push({ query: filters })
  }
}